/*
  Vacker: stock squares (Webblager / Butiker) + review stars (1+ reviews) under the price on product cards
  on collection pages – works with the filter app's cards (.spf-product-card)
  and the theme's own cards (.product-card.product-grid).
  Data: /variants/<id>/?section_id=vacker-stock-status (sections/vacker-stock-status.liquid)
  Only cards that scroll into view are fetched; results are cached for 10 minutes.
*/
(function () {
  if (window.__vackerStockStatus) return;
  window.__vackerStockStatus = true;

  var SECTION_ID = 'vacker-stock-status';
  var CARD_SELECTOR = '.spf-product-card, .product-card.product-grid';
  var PRICE_SELECTOR = '.spf-product-card__price-wrapper, .product-group-price';
  var CACHE_PREFIX = 'vkStock3:';
  var CACHE_TTL = 10 * 60 * 1000;
  var MAX_PARALLEL = 6;
  var STORES_GREEN_FROM = 3; // 1–2 stores = orange ("få butiker")
  var STAR = '<svg viewBox="0 0 20 20" width="14" height="14"><path d="M10 1.5l2.6 5.5 6 .8-4.4 4.2 1.1 6-5.3-2.9-5.3 2.9 1.1-6L1.4 7.8l6-.8z"/></svg>';
  var STARS = STAR + STAR + STAR + STAR + STAR;

  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var promises = {};
  var queue = [];
  var active = 0;

  // Variant shown on the card: the card's add-to-cart "id" field (first available variant)
  function handleOf(card) {
    var field = card.querySelector('[name="id"]');
    var id = field && field.value;
    return id && /^\d+$/.test(id) ? id : null;
  }

  function readCache(handle) {
    try {
      var v = JSON.parse(sessionStorage.getItem(CACHE_PREFIX + handle));
      if (v && Date.now() - v.t < CACHE_TTL) return v.d;
    } catch (e) {}
    return null;
  }

  function writeCache(handle, data) {
    try { sessionStorage.setItem(CACHE_PREFIX + handle, JSON.stringify({ t: Date.now(), d: data })); } catch (e) {}
  }


  // Webblager low stock: same data + rule as the "Invo stock by location" widget
  // (0 = slut, 1..lowStockThreshold = lågt lagersaldo, above = i lager).
  // Threshold is read from the app's own setting. Falls back to yes/no if unavailable.
  function addWebblagerLevel(data, variantId) {
    if (!data || !data.productId) return data;
    return fetch(root + 'apps/invo-stock-by-location/api/inventory/' + data.productId + '?countryCode=SE', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (inv) {
        try {
          if (!inv || !inv.variants) return data;
          var variant = inv.variants.filter(function (v) { return String(v.id) === String(variantId); })[0] || inv.variants[0];
          var loc = (variant.locations || []).filter(function (l) { return /webblager/i.test(l.name || ''); })[0];
          if (!loc || loc.quantityAvailable == null) return data;
          var qty = parseInt(String(loc.quantityAvailable).replace(/\+\s*$/, ''), 10);
          var threshold = inv.settings && inv.settings.lowStockThreshold != null ? Number(inv.settings.lowStockThreshold) : 5;
          data.webStatus = isNaN(qty) || qty <= 0 ? 'out_of_stock' : (qty <= threshold ? 'low_stock' : 'in_stock');
        } catch (e) {}
        return data;
      })
      .catch(function () { return data; });
  }

  function pump() {
    while (active < MAX_PARALLEL && queue.length) {
      (function (job) {
        active++;
        fetch(root + 'variants/' + job.handle + '/?section_id=' + SECTION_ID, { credentials: 'same-origin' })
          .then(function (r) { return r.ok ? r.text() : null; })
          .then(function (text) {
            var data = null;
            var m = text && text.match(/<script[^>]*data-vacker-stock[^>]*>([\s\S]*?)<\/script>/);
            if (m) { try { data = JSON.parse(m[1]); } catch (e) {} }
            return addWebblagerLevel(data, job.handle);
          })
          .then(function (data) {
            if (data) writeCache(job.handle, data);
            job.resolve(data);
          })
          .catch(function () { job.resolve(null); })
          .then(function () { active--; pump(); });
      })(queue.shift());
    }
  }

  function load(handle) {
    if (promises[handle]) return promises[handle];
    var cached = readCache(handle);
    promises[handle] = cached
      ? Promise.resolve(cached)
      : new Promise(function (resolve) { queue.push({ handle: handle, resolve: resolve }); pump(); });
    return promises[handle];
  }

  function square(label, status, title) {
    var el = document.createElement('span');
    el.className = 'vk-stock__item vk-stock__item--' + status;
    el.textContent = label;
    el.title = title;
    el.setAttribute('aria-label', title);
    return el;
  }

  function render(card, data) {
    var price = card.querySelector(PRICE_SELECTOR);
    if (!price || !data) return;
    var old = card.querySelector('.vk-stock');
    if (old) old.remove();
    var oldRating = card.querySelector('.vk-rating');
    if (oldRating) oldRating.remove();

    var wrap = document.createElement('div');
    wrap.className = 'vk-stock';

    var webStatus = data.webStatus || (data.web ? 'in_stock' : 'out_of_stock');
    var webTitle = webStatus === 'in_stock' ? 'Webblager: I lager'
      : (webStatus === 'low_stock' ? 'Webblager: Lågt lagersaldo' : 'Webblager: Slut i lager');
    wrap.appendChild(square('Webblager', webStatus, webTitle));

    var n = data.stores || 0;
    var storeStatus = n >= STORES_GREEN_FROM ? 'in_stock' : (n > 0 ? 'low_stock' : 'out_of_stock');
    var storeTitle = n > 0
      ? 'Butiker: I lager i ' + n + (n === 1 ? ' butik' : ' butiker') + ' (' + (data.storeNames || []).join(', ').replace(/&amp;/g, '&') + ')'
      : 'Butiker: Slut i lager';
    wrap.appendChild(square('Butiker', storeStatus, storeTitle));

    price.insertAdjacentElement('afterend', wrap);

    // Review stars (only when the product has at least 1 review)
    var count = parseInt(data.reviews, 10) || 0;
    var rating = parseFloat(data.rating) || 0;
    var max = parseFloat(data.ratingMax) || 5;
    if (!(count >= 1 && rating > 0)) {
      // No reviews: keep an empty row of the same height so all cards line up
      var spacer = document.createElement('div');
      spacer.className = 'vk-rating vk-rating--empty';
      spacer.setAttribute('aria-hidden', 'true');
      wrap.insertAdjacentElement('afterend', spacer);
    }
    if (count >= 1 && rating > 0) {
      var link = card.querySelector('a[href*="/products/"]');
      var url = link ? link.getAttribute('href').split('#')[0] : null;
      var pct = Math.max(0, Math.min(100, (rating / max) * 100));
      var label = 'Betyg ' + String(Math.round(rating * 10) / 10).replace('.', ',') + ' av 5, ' + count + (count === 1 ? ' recension' : ' recensioner');
      var el = document.createElement(url ? 'a' : 'div');
      el.className = 'vk-rating';
      if (url) el.href = url + '#fulfilled-reviews-all';
      el.setAttribute('aria-label', label);
      el.title = label;
      el.innerHTML =
        '<span class="vk-rating__stars" aria-hidden="true">' +
          '<span class="vk-rating__empty">' + STARS + '</span>' +
          '<span class="vk-rating__fill" style="width:' + pct.toFixed(1) + '%">' + STARS + '</span>' +
        '</span>' +
        '<span class="vk-rating__count" aria-hidden="true">(' + count + ')</span>';
      wrap.insertAdjacentElement('afterend', el);
    }
  }


  // ---------------------------------------------------------------------------
  // Equal card layout: in every row of cards, line up title, price, stock
  // squares and review stars (badges and 1–2 line titles can differ per card).
  // ---------------------------------------------------------------------------
  var ALIGN_GROUPS = [
    ['.spf-product-card', ['.spf-product-card__title', '.spf-product-card__price-wrapper', '.vk-stock', '.vk-rating']],
    ['.collection .product-card.product-grid', ['.product-card__name', '.product-group-price', '.vk-stock', '.vk-rating']]
  ];

  function equalize() {
    ALIGN_GROUPS.forEach(function (group) {
      var cards = Array.prototype.filter.call(document.querySelectorAll(group[0]), function (c) {
        return c.offsetParent !== null;
      });
      var slots = group[1];
      cards.forEach(function (c) {
        slots.forEach(function (s) { var e = c.querySelector(s); if (e) e.style.marginTop = ''; });
      });
      var rows = {};
      cards.forEach(function (c) {
        var key = Math.round((c.getBoundingClientRect().top + window.pageYOffset) / 4);
        (rows[key] = rows[key] || []).push(c);
      });
      Object.keys(rows).forEach(function (key) {
        var row = rows[key];
        if (row.length < 2) return;
        slots.forEach(function (s) {
          var els = row.map(function (c) { return c.querySelector(s); });
          var tops = els.map(function (e) { return e ? e.getBoundingClientRect().top : null; });
          var present = tops.filter(function (t) { return t !== null; });
          if (!present.length) return;
          var max = Math.max.apply(null, present);
          els.forEach(function (e, i) {
            if (!e || max - tops[i] < 0.5) return;
            var base = parseFloat(getComputedStyle(e).marginTop) || 0;
            e.style.marginTop = (base + max - tops[i]) + 'px';
          });
        });
      });
    });
  }

  var eqTimer, eqLateTimer;
  function scheduleEqualize() {
    clearTimeout(eqTimer); clearTimeout(eqLateTimer);
    eqTimer = setTimeout(equalize, 120);
    eqLateTimer = setTimeout(equalize, 800); // second pass after badges/fonts settle
  }
  window.addEventListener('resize', scheduleEqualize);
  window.addEventListener('load', scheduleEqualize);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(scheduleEqualize);

  function process(card) {
    var handle = card.getAttribute('data-vk-handle');
    if (!handle) return;
    load(handle).then(function (data) {
      if (card.getAttribute('data-vk-handle') === handle) render(card, data);
      scheduleEqualize();
    });
  }

  var io = 'IntersectionObserver' in window
    ? new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { io.unobserve(e.target); process(e.target); }
        });
      }, { rootMargin: '300px 0px' })
    : null;

  function scan() {
    var cards = document.querySelectorAll(CARD_SELECTOR);
    for (var i = 0; i < cards.length; i++) {
      var card = cards[i];
      var handle = handleOf(card);
      if (!handle) continue;
      if (card.getAttribute('data-vk-handle') === handle && card.querySelector('.vk-stock')) continue;
      card.setAttribute('data-vk-handle', handle);
      if (io) io.observe(card); else process(card);
    }
  }

  var timer;
  function scheduleScan() { clearTimeout(timer); timer = setTimeout(function () { scan(); scheduleEqualize(); }, 150); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan); else scan();
  new MutationObserver(scheduleScan).observe(document.body, { childList: true, subtree: true });
})();
